import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/config/firebase';
import type { CollaboratorPublic } from '@/features/Collaborators/Data/hooks/useCollaboratorsPublicQuery';

export async function fetchCollaboratorProfiles(
    collaboratorIds: string[]
): Promise<Map<string, CollaboratorPublic>> {
    const profiles = new Map<string, CollaboratorPublic>();
    if (collaboratorIds.length === 0) return profiles;

    const snaps = await Promise.all(
        collaboratorIds.map((id) => getDoc(doc(db, 'collaborators_public', id)))
    );
    snaps.forEach((snap) => {
        if (snap.exists()) {
            profiles.set(snap.id, snap.data() as CollaboratorPublic);
        }
    });
    return profiles;
}
